import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useHomepageContent } from '../lib/hooks/useHomepageContent';
import RichText from './RichText';

const getIconComponent = (iconName: string, iconColor: string) => {
  const IconComponent = (LucideIcons as any)[iconName];
  if (!IconComponent) {
    return <LucideIcons.Building2 className={`w-8 h-8 ${iconColor}`} />;
  }
  return <IconComponent className={`w-8 h-8 ${iconColor}`} />;
};

const ProjectInfo = () => {
  const { content, loading: contentLoading } = useHomepageContent();

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 left-10 w-32 h-32 bg-secondary rounded-full opacity-10"></div>
        <div className="absolute bottom-20 right-10 w-48 h-48 bg-accent rounded-full opacity-10"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-r from-primary/5 to-secondary/5 rounded-full"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-primary">{contentLoading ? 'Зареждане...' : content.projectInfo.title}</span>
            <span className="block text-secondary mt-2">{contentLoading ? '' : content.projectInfo.subtitle}</span>
          </h2>
          <div className="flex items-center justify-center space-x-4 mb-6">
            <div className="w-16 h-1 bg-primary rounded-full"></div>
            <div className="w-3 h-3 bg-secondary rounded-full"></div>
            <div className="w-16 h-1 bg-primary rounded-full"></div>
          </div>
          {contentLoading ? (
            <p className="text-xl text-neutral-600 max-w-4xl mx-auto leading-relaxed">
              Зареждане на описанието...
            </p>
          ) : (
            <RichText
              value={content.projectInfo.description}
              className="text-xl text-neutral-600 max-w-4xl mx-auto leading-relaxed"
            />
          )}
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {content.projectInfo.features
            ?.filter(Boolean)
            .sort((a, b) => a.order - b.order)
            .map((feature) => (
            <div
              key={feature.id}
              className="group relative bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-neutral-100 hover:border-primary/20"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 p-3 rounded-lg bg-gradient-to-br from-neutral-50 to-neutral-100 group-hover:from-primary/10 group-hover:to-secondary/10 transition-all duration-300">
                  {getIconComponent(feature.icon, feature.iconColor)}
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-neutral-800 mb-2 group-hover:text-primary transition-colors">
                    {feature.title}
                  </h3>
                  <RichText
                    value={feature.description}
                    className="text-neutral-600 text-sm leading-relaxed"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectInfo;
